function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyDotted = function SvgEmptyDotted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 23.75,
    cy: 23.75,
    r: 23,
    stroke: props.fill,
    fill: "none",
    strokeDasharray: "5 7",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5
  }));
};
export default SvgEmptyDotted;